import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingPanelComponent } from '../shared/components/loading-panel';
import { SecurityService } from '../shared/security/security.service';

@Component({
  selector: 'ntw-select-account',
  templateUrl: './select-account.component.html',
  styleUrls: ['./select-account.component.scss'],
  imports: [LoadingPanelComponent, TranslateModule]
})
export class SelectAccountComponent implements OnInit {
  loading = false;

  constructor(private router: Router,
    public securityService: SecurityService
  ) { }

  ngOnInit(): void {
    const customerAxCodes = this.securityService.getCustomerAxCodes();
    if (customerAxCodes.length === 1) {
      this.loading = true;
      this.router.navigate(['account', customerAxCodes[0]]).finally(() => {
        this.loading = false;
      });
    }
  }
}
